import InnerCircle, {InnerCircleProps} from './InnerCircle';

export type {InnerCircleProps};
export default InnerCircle;
